import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Header.css';
import aimLogo from '../assets/images/hkaim_logo.png';
import mcaLogo from '../assets/images/mca_logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setIsAdmin(false);
    navigate('/');
    closeMenu();
  };

  const navItems = [
    { path: '/', label: '首頁 Home' },
    { path: '/voting', label: '投票 Voting' },
    { path: '/results', label: '結果 Results' },
    ...(isAdmin ? [{ path: '/admin', label: '管理 Admin' }] : []),
  ];

  const isActive = (path) => location.pathname === path;

  

  return (
    <header className="header">
      <div className="header-content">
        <a href="https://www.hkaim.org/" className="logo" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <img src={aimLogo} alt="AIM Logo" />
          </motion.div>
        </a>
        <a href="/" className="logo" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <img className="logo-img" src={mcaLogo} alt="MCA Logo" />
          </motion.div>
        </a>
        {/* <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            {navItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link
                  to={item.path}
                  className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav> */}
        {/* <div className="header-actions">
          {isLoggedIn ? (
            <motion.button
              className="btn btn-secondary"
              onClick={handleLogout}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              登出 Logout
            </motion.button>
          ) : (
            <div className="auth-buttons">
              <Link to="/login">
                <motion.button
                  className="btn btn-secondary"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  登入 Login
                </motion.button>
              </Link>
              <Link to="/register">
                <motion.button
                  className="btn btn-primary"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  註冊 Register
                </motion.button>
              </Link>
            </div>
          )}
        </div>
        <button
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button> */}
      </div>
      
      {/* Main Header Banner */}
      <div className="header-banner">
        <div className="container">
          <div className="banner-content">
            <h2 className="banner-subtitle">
              第十一屆「傳媒轉型大獎」
            </h2>
            <h2 className="banner-subtitle">
              The 11<sup>th</sup> Media Convergence Awards
            </h2>
            <div className="banner-description">
              <p>
                由 <span className="focus">香港互動市務商會(AIM)</span> 舉辦的 第十一屆「傳媒轉型大獎」 現正接受公眾投票!
              </p>
              <p>
                請立即投選<span className="focus">十大熱門媒體網站</span>、<span className="focus">十大熱門社交媒體專頁</span> 及 <span className="focus">最熱門 OTT 平台</span>，
                <br/>支持您心目中最優秀的傳媒，推動傳媒產業步向卓越及創新!
              </p>
              <p>
                歡迎鼓勵朋友投票，一同參與本年度傳媒盛事!
              </p>
              <p className="voting-period">
                投票期: 2026年9月1日（中午12時正）至2026年9月30日（晚上11時59分）
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
